import request from "@assets/js/axios";
const {
  instance: $axios
} = request;
class Visa {
  constructor() { }
  getFaqDetail(id) {
    return $axios.get('commonFaq/get?id=' + id);
  }
  // 搜索常见问题
  getFaqList(data) {
    return $axios.get('/commonFaq/pageQuery', {
      params: data
    })
  }
  // 添加订单
  addOrder(data) {
    return $axios.post("/VisaOrder/store", data);
  }
  // 签证各洲城市
  getCountry() {
    return $axios.get("/homeByIp");
  }
  // 获取搜索列表参数
  getSearchData() {
    return $axios.get("/VisaOrder/commonBase");
  }
  // 获取签证列表
  list(data) {
    return $axios.get("/VisaOrder/getOrdersByUser", {
      params: data
    });
  }
  // 签证详情
  detail(OrderNO) {
    return $axios.get("/VisaOrder/getOrderByUser", {
      params: {
        OrderNO
      }
    });
  }
  // 支付结果
  payResult(OrderNO) {
    return $axios.get("/VisaOrder/getOrderPayStatus", {
      params: {
        OrderNO
      }
    });
  }
  payInfo(OrderNO) {
    return $axios.get("/Yspay/request", {
      params: {
        payment_type: 'YspayAlipay',
        order_type: 'visa',
        order_sn: OrderNO
      }
    })
  }
  getProductDetail(id) {
    return $axios.get(`/VisaProduct/detail/${id}`)
  }
  getProductList(id) {
    return $axios.get(`/VisaProduct/byCountry/${id}`)
    // return $axios.get(`/apiv1/goods/visa/byCountry?country_id=${id}`)
  }

  getAd() {
    return $axios.get('/visaAd');
  }
  // ------------------------- 新接口 -------------------------------
  // 获取热门国家相关数据
  getHotSalesCountryInfo() {
    return $axios.get('/apiv1/goods/visa/byContinent');
  }

  // 通过国家ID获取该国家的产品列表
  getVisaProductList(country_id) {
    return $axios.get(`/apiv1/goods/visa/byCountry?country_id=${country_id}`)
  }
  // 通过ID获取签证详情
  // getVisaProductDetail(id) {
  //   return $axios.get(`/apiv1/goods/visa/get?id=${id}`)
  // }

  //新版  通过ID获取签证详情
  getVisaProductDetail(id) {
    return $axios.get(`/apiv2/goods/visa/info?id=${id}`)
  }

  // 创建订单
  create_Xorder(param) {
    return $axios.post("/api/xorder/save", param);
  }
  // 通过订单ID获取订单详情内容
  getOrderDetailByOrdersn(order_sn) {
    return $axios.get("/api/xorder/detail", {
      params: {
        order_sn
      }
    });
  }
  // 获取 支付宝方式的订单支付信息
  getAliPayQrcode(param) {
    return $axios.get("/api/v2/Yspay/request", {
      params: param
    });
  }

  // 首页获取签证产品列表
  getHomeVisaProductList() {
    return $axios.get("/apiv1/goods/visa/byContinent");
  }

  // 首页获取可预约日期相关信息
  // getAppointmentInfo() {
  //   return $axios.get("/api-1/appointment/getHuYiData?token_key=");
  // }
  // 通过国家ID，获取该国家的节假日列表
  getHolidayByCountryId(VisaCountryID) {
    return $axios.get(`/apiv1/goods/holiday/list?VisaCountryID=${VisaCountryID}`)
  }

}

export default new Visa();